import { IProjects } from '@/interface/IProjects'
import { baseApi } from './BaseApi'
import { ITimecard } from '@/interface/ISelectedDate'
import { IJournal } from '@/interface/IJournal'
import { IOrdersRef } from '@/interface/IOrder'

export const injectedEndpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getTimecard: builder.query<ITimecard, string>({
            query: (date) => `Timecard?date=${date}`,
            providesTags: ['Timecard'],
        }),
        getJournal: builder.query<IJournal, string>({
            query: (date) => `Journal?date=${date}`,
            providesTags: ['Journal'],
        }),
        getReportFAK: builder.query<undefined, string>({
            query: (date) => `ReportFAK?date=${date}`,
            providesTags: ['ReportFAK'],
        }),
        getReport: builder.query<undefined, string>({
            query: (date) => `Report?date=${date}`,
            providesTags: ['Report'],
        }),
        getProjects: builder.query<IProjects, string>({
            query: (date) => `Projects?date=${date}`,
            providesTags: ['Projects'],
        }),
        getOrders: builder.query<IOrdersRef[], string>({
            query: (date) => `Orders?date=${date}`,
            providesTags: ['Orders'],
        }),
        getTemplates: builder.query({
            query: () => `Template`,
            providesTags: ['Templates'],
        }),
    }),
})

export const { useGetTimecardQuery, useGetProjectsQuery } = injectedEndpoints
